module.exports = __webpack_public_path__ + "static/media/create-account-desktop.04680d83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/create-account-desktop.jpg
// module id = 441
// module chunks = 0